// JavaScript Document

var params = { 
  apiKey: 'TjwkNHFqae7dbGldVHNt8zfLLAMuwJ9pt1wh35Hg',
  config: {
    useV5: true,
  },
};


// This function will be called when the page is loaded and ready
function fitmixer(id) {  
  
  // create fitmix only once 
  fitmixInstance = FitMix.createWidget('fitmixContainer', params,  function() {
    console.log('fitmixInstance ready.');
    fitmixInstance.setFrame('' + id + '');
  });
};

/*
 There are 2 behavior possible when closing the popup.
 Option 1: pauseStream / resumeStream
 You can choose to pause the stream
 This will keep the camera opened and make the resume faster.
 
 Option 2: closeCamera / openCamera
 You can choose to close the camera. 
 Camera access is released
 User will be prompted access of the camera when calling openCamera on safari
*/

// You can choose to hide the popup between 2 tryon
var hidePopup = function() {
  document.getElementById('popupContainer').style.display = 'none';
  //document.getElementById('my-vto-settings').style.display = 'none';
  document.getElementById('product-grid-images').style.height = '100%';
  //document.getElementById('trymeon-m').style.display = 'block';
  //document.getElementById('trymeon-on').style.display = 'none';
  //document.getElementById('trymeon-m-on').style.display = 'none';
  myFitmixWidget.pauseStream(); // -> this stop the stream but keep the camera opened
  //myFitmixWidget.closeCamera(); // -> this stop the camera completely 
};

var showme = function() {
  document.getElementById('popupContainer').style.display = 'block';
  document.getElementById('product-grid-images').style.height = '1px' ;
};


window.toggleElement = function(elementName, forceDisplayValue) {
    var el = document.querySelector(elementName);

    var value = '';
    if (forceDisplayValue === false) {
        value = 'none';
    } else if (forceDisplayValue === true) {
        value = 'block';
    } else {
        if (el.style.display === 'none') {
            value = 'block';
        } else {
            value = 'none';
        }
    }
    el.style.display = value;
};

function GenderMe(mf) {
  fitmixInstance.setUserInfo({gender: '' + mf + ''});
  document.getElementById('fitmixContainer2').style.display = 'none';
}

function Mapit(){
  var actualpupillarydistance=parseInt(pupillarydistance.options[pupillarydistance.selectedIndex].value);
  fitmixInstance.setPupillaryDistance(actualpupillarydistance);
  document.getElementById('fitmixContainer2').style.display = 'none';
}
